import React, { PureComponent } from "react";
import { fetchProject } from "../../../../actions/project";
import { Col, Row } from "../../../../common/grid";
import { connect } from "react-redux";
import moment from "moment";
import UserCard from "../../../../common/userCard/UserCard";
import DonorCard from "../../../../common/donorCard/DonorCard";
import AttachmentCounter from "../_common/AttachmentCounter";
import Modal from "../../../../common/modal/Modal";
import DownloadModalContent from "../_common/DownloadModalContent";
import ProgressBar from '../index/ProgressBar';
import "./Project.css";


/**
 * ATTACHMENT TYPES
 * 1 - Description attachment
 * 2 - Proposal Attachment
 * 3 - Budget Attachment
 * 4 - Document Attachment
 * 5 - Concept note attachment
 * 6 - Contract attachment
 * 7 - Photos attachment
 * 8 - Purchases attachment
 */

class Project extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			selectedType: "NONE" // can be numbers between 1 - 8 or "NONE"
		};
	}

	closeModal = () => {
		this.setState({ selectedType: "NONE" });
	};

	selectAttachmentType = type => {
		this.setState({ selectedType: type });
	};

	componentDidMount = () => {
		this.props.fetchProject(this.props.match.params.id);
	};

	render() {
		const { project } = this.props;
		const { selectedType } = this.state;

		const startMs = moment(project.start_date).valueOf();
		const endMs = moment(project.end_date).valueOf();
		const current = moment().valueOf() - startMs;
		const range = endMs - startMs;

		const progress = (current / range) * 100;

		// groups attachment counts by type
		const attachments = project.attachments.reduce((obj, x) => {
			obj[x.type] = obj[x.type] + 1 || 1;
			return obj;
		}, {});

		const selectedAttachments = project.attachments.filter(
			a => a.type === selectedType
		);

		return (
			<Col _bottom-32 project>
				{project.photo_url && <img src={project.photo_url} alt="" />}
				<Col _bottom-16>
					<Row _gap-16 _no-grow _align-center>
						<h1>{project.name}</h1>
						{project.rejected === 1 && <span> - </span>}
						{project.rejected === 1 && <div className="danger">Rejected</div>}
					</Row>
					<Row _no-grow _gap-16 desc-container>
						<AttachmentCounter
							onClick={this.selectAttachmentType}
							attachments={attachments}
							type={"1"}
						/>
						<div className="desc">{project.description}</div>
					</Row>
				</Col>

				<Col _bottom-8>
					<Row _gap-16 _no-grow _align-center desc-row>
						<AttachmentCounter
							onClick={this.selectAttachmentType}
							attachments={attachments}
							type={"3"}
						/>
						<span className="property">Budget:</span>
						<span className="value">{project.budget}</span>
					</Row>
					<Row _gap-16 _no-grow _align-center desc-row>
						<AttachmentCounter
							onClick={this.selectAttachmentType}
							attachments={attachments}
							type={"2"}
						/>
						<span className="property">Proposal:</span>
						<span className="value">{project.proposal}</span>
					</Row>
					<Row _gap-16 _no-grow _align-center desc-row>
						<AttachmentCounter
							onClick={this.selectAttachmentType}
							attachments={attachments}
							type={"5"}
						/>
						<span className="property">Concept note:</span>
						<span className="value">{project.concept_note_text}</span>
					</Row>
					<Row _gap-16 _no-grow _align-center desc-row>
						<AttachmentCounter
							onClick={this.selectAttachmentType}
							attachments={attachments}
							type={"6"}
						/>
						<span className="property">Contract:</span>
						<span className="value">{project.contract_text}</span>
					</Row>
					<Row _gap-16 _no-grow _align-center desc-row>
						<AttachmentCounter
							onClick={this.selectAttachmentType}
							attachments={attachments}
							type={"8"}
						/>
						<span className="property">Purchases:</span>
						<span className="value">{project.purchases_text}</span>
					</Row>
					<Row _gap-16 _no-grow _align-center desc-row>
						<AttachmentCounter
							onClick={this.selectAttachmentType}
							attachments={attachments}
							type={"4"}
						/>
						<span className="property">documnets (title):</span>
						<span className="value">{project.documents_text}</span>
					</Row>
					<Row _gap-16 _no-grow _align-center desc-row>
						<AttachmentCounter
							onClick={this.selectAttachmentType}
							attachments={attachments}
							type={"7"}
						/>
						<span className="property">photos (title):</span>
						<span className="value">{project.photos_text}</span>
					</Row>
				</Col>

				<Col _bottom-8>
					<div className="dates">
						{moment(project.start_date).format("ll")}
						{"  -  "}
						{moment(project.end_date).format("ll")}
						{moment().unix() > moment(project.end_date).unix() && " (over)"}
					</div>
					<ProgressBar progress={progress}/>
					{/* <div className="progress">
						<div className="bar" style={{ width: progress }} />
					</div> */}
				</Col>

				{project.assets.length > 0 && (
					<Col _bottom-8>
						<h2>Assets:</h2>
						<Col _bottom-4 assets>
							{project.assets.map(a => (
								<div key={a.id}>
									{a.name} - <span className="light">{a.description}</span>
								</div>
							))}
						</Col>
					</Col>
				)}

				{project.users.length > 0 && (
					<Col _bottom-8>
						<h2>Users:</h2>
						<Row _wrap projectsInner_users>
							{project.users.map(u => (
								<UserCard user={u} key={u.id} />
							))}
						</Row>
					</Col>
				)}

				{project.donors.length > 0 && (
					<Col _bottom-8>
						<h2>Donors:</h2>
						<Row _wrap>
							{project.donors.map(d => (
								<DonorCard donor={d} key={d.id} />
							))}
						</Row>
					</Col>
				)}

				{selectedType !== "NONE" && (
					<Modal onCancel={this.closeModal}>
						<DownloadModalContent attachments={selectedAttachments} />
					</Modal>
				)}
			</Col>
		);
	}
}

const mapStateToProps = state => {
	return {
		project: state.project.selected
	};
};

const mapDispatchToProps = {
	fetchProject
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Project);



// WEBPACK FOOTER //
// ./src/components/main/projects/project/Project.js